import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { tagPicker_template } from "./tagPicker_template";
import { imagePicker_template } from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import { filterDropdown_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template';
import { filterSingleDate_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template'
import { filterArticle_template } from "./filterArticle_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import { videoPickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper";
import videoPicker_template from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template";
import NwsLAB from '../../utils/NewsletterArticlePickerBuilder';
import {newsletterTargetingBuilder_template} from "./newsletterTargetingBuilder_template";

declare var ko: any;

export class newsletterMailEdit_template extends vnTemplate {

    public imagePicker: imagePicker_template;
    public tagPicker: tagPicker_template;
    protected templateSelector: filterDropdown_template;
    protected dateSelector: filterSingleDate_template;
    public articleFilter: filterArticle_template;
    protected customRecipientsToolTipButton: infoButton_template;
    protected contentToolTipButton: infoButton_template;
    public filterProducts: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public imagePickerHelper: imagePickerHelper;
    public tagVideoPicker: videoPicker_template;
    public videoPickerHelper: videoPickerHelper;
    public targetingBuilder: newsletterTargetingBuilder_template;
    protected getTemplateHtml(): string {

        return /*html*/`
        ${window.location.pathname.indexOf('/newsletter/emails/add')> -1 ?
            /*html*/`
        <div data-bind="visible:!selectedNewsLetterMode()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
            <div class="form-header">
                <strong class="form-title">Select Layout</strong>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group group-3" style="grid-template-columns: none;">
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:() => onClickSelectNewsLetterMode('regular')">
                            <div class="w-icon"><span class="icon i-newsletter"></span></div>
                            <div class="temp-info"><span>Regular</span><p>Provides standard elements with CSS automatically applied</p></div>
                        </button>
                    </div>
                    <div class="form-group group-4" style="grid-template-columns: none;">
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:() => onClickSelectNewsLetterMode('Custom Content')">
                            <div class="w-icon"><span class="icon i-star-full"></span></div>
                            <div class="temp-info"><span>Custom Content</span><p>Allows custom elements and inline CSS within the content. Uses the template header and footer.</p></div>
                        </button>
                    </div>
                    <div class="form-group group-5" style="grid-template-columns: none;">
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:() => onClickSelectNewsLetterMode('Custom Header/Content/Footer')">
                            <div class="w-icon"><span class="icon i-star-full"></span></div>
                            <div class="temp-info"><span>Custom Header/Content/Footer</span><p>Allows full control within the body tag. Does not include a header, content, or footer.</p></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div data-bind="visible:(selectedNewsLetterMode() == 'Custom Content' || selectedNewsLetterMode() == 'Custom Header/Content/Footer') && !selectedTemplateId()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
            <div class="form-header">
                <strong class="form-title">Select Template</strong>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group group-4 overflow-scroll">
                        <!-- ko foreach: availableNewsLetterTemplates -->
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:($data) => $parent.onClickSelectTemplate($data)">
                            <div class="w-icon"><span class="icon i-regular-template"></span></div>
                            <div class="temp-info"><span data-bind="text:$data.name"></span></div>
                        </button>
                        <!-- /ko -->
                    </div>
                </div>
            </div>
        </div>` : '' }

            <div class="w-form w-form-large" data-bind="visible: ((selectedNewsLetterMode() == 'Custom Content' || selectedNewsLetterMode() == 'Custom Header/Content/Footer') && selectedTemplateId()) || (selectedNewsLetterMode() == 'regular')">
                <div class="form-header">
                    <h3 class="form-title">Newsletter Builder</h3>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

                </div>
                <div class="form-body">

                    <div class="form-group">
                        <label for="subject" class="form-label">Subject</label>
                        <div class="row link">
                            <input id="subject" data-bind="value: subject" type="text" class="input-text">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="previewText" class="form-label">Preview Text</label>
                        <div class="row link">
                            <input id="previewText" data-bind="value: previewText" type="text" class="input-text">
                        </div>
                    </div>
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Layout</span></dt>
                            <dd><span data-bind="text:selectedNewsLetterMode()"></span></dd>
                        </dl>
                        <dl class="double-list">
                            <dt><span>Template</span></dt>
                            <dd><span data-bind="text: selectedTemplate() && selectedTemplate().name ? selectedTemplate().name : ''"></span></dd>
                         </dl>
                    </div>
                    <div class="form-group ">
                         <div style="display: flex;align-items: center;justify-content: space-between">
                             <label for="contenttext" class="form-label">Content</label>
                             <div class="w-tooltips-adv pos-left">
                                 ${this.contentToolTipButton.getHtmlBuild()}
                             </div>
                         </div>
                         <textarea id="contenttext" data-bind="value: content" ></textarea>
                    </div>

                </div>

                 <div class="form-footer">
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                    <button data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, true) }, visible: permissions()['newsletter_email_edit'].write" class="btn highlight" type="button">Save & Send</button>
                </div>
            </div>

            ${this.imagePicker.getHtmlBuild()}
            ${this.tagPicker.getHtmlBuild()}

            <div data-bind="css: { 'is-visible': isArticleInsertPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Article</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseArticlePopUp }" ></button>
                        </div>
                        <div class="form-body w-article-picker" style="padding:2rem">
                            ${this.articleFilter.getHtmlBuild()}
                            <div class="preview" data-bind="visible: articleInsertPreviewCode">
                                <div class="form-group">
                                    <div class="scrollable" style="max-width:50vw;"  data-bind="html: articleInsertPreviewCode, disable: true" ></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseArticlePopUp }" class="btn ">Cancel</button>
                            <button type="button" data-bind="disable: articleInsertPreviewCode() == '',  event: { click: onClickInsertIntoEditor }" class="btn highlight">Insert</button>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isSaveAndSendPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content" id="newsletter-confirm-identifier">
                    <div class="w-form lightbox-form" style="width: 100rem">
                        <div class="form-header">
                            <h3 class="form-title">Save and Send</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }" ></button>
                        </div>
                        <div class="form-body newsletter-save-send-body">

                            <strong class="form-sub-title">INFORMATION</strong>
                            <div class="form-group">
                                <div class="form-check-inline" data-bind="visible: selectedNewsLetterMode() == 'regular'">
                                    <label for="date" class="form-label">Template</label>
                                    ${this.templateSelector.getHtmlBuild()}
                                </div>
                                <div class="form-check-inline">
                                    <label for="date" class="form-label">Date Scheduled</label>
                                    ${this.dateSelector.getHtmlBuild()}
                                </div>
                            </div>
                            <strong class="form-sub-title parent">Recipients</strong>
                            <div class="form-group newsletter-recipient-modes">
                                <div class="form-check-inline">
                                    <input id="recipient-mode-mailing-list" type="radio" name="recipientMode" value="mailingList" data-bind="checked: recipientMode">
                                    <label for="recipient-mode-mailing-list" class="form-label">Mailing List</label>
                                </div>
                                <div class="form-check-inline">
                                    <input id="recipient-mode-segment" type="radio" name="recipientMode" value="segment" data-bind="checked: recipientMode">
                                    <label for="recipient-mode-segment" class="form-label">Segment</label>
                                </div>
                                <div class="form-check-inline">
                                    <input id="recipient-mode-custom" type="radio" name="recipientMode" value="custom" data-bind="checked: recipientMode">
                                    <label for="recipient-mode-custom" class="form-label">Custom</label>
                                </div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'mailingList'">
                                <strong class="form-sub-title content">Mailing Lists</strong>
                                <div class="form-group mailinglist">
                                    <div data-bind="foreach: recipients">
                                        <input type="checkbox" data-bind="attr: {id: 'recipient' + id}, value: id, checked: $parent.selectedRecipients">
                                        <label class="form-label icon i-check" data-bind="text: name, attr: {for: 'recipient' + id}"></label>
                                    </div>
                                </div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'segment'">
                                <strong class="form-sub-title content">Segments</strong>
                                <div class="form-group mailinglist">
                                    <div data-bind="foreach: availableSegments">
                                        <input type="checkbox" data-bind="attr: {id: 'segment-recipient-' + id}, value: id, checked: $parent.selectedSegmentIds">
                                        <label class="form-label icon i-check" data-bind="text: title, attr: {for: 'segment-recipient-' + id}"></label>
                                    </div>
                                </div>
                            </div>

                            <div data-bind="visible: recipientMode() === 'custom'">
                                <strong class="form-sub-title content">Custom Targeting</strong>
                                <p class="form-text">Direct email recipients are added to the send and are not filtered by targeting rules.</p>
                                ${this.targetingBuilder.getHtmlBuild()}
                            </div>

                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            <div class="form-group newsletter-send-to-self">
                                <div class="form-check-inline">
                                    <input id="myself" data-bind="checked: sendToSelf, value: 'self'" type="checkbox">
                                    <label for="myself" class="form-label icon i-check">Send to Email Address of Logged In User</label>
                                </div>
                            </div>

                            <div class="newsletter-segment-audience-accordion">
                                <strong class="form-sub-title content newsletter-segment-audience-accordion-title icon i-dropdown-simple" data-bind="event: { click: onClickToggleAudienceTools }, css: { 'is-open': isAudienceToolsOpen }, attr: { 'aria-expanded': isAudienceToolsOpen() ? 'true' : 'false' }">Audience Tools</strong>
                                <div data-bind="visible: isAudienceToolsOpen">
                                    <div class="form-group newsletter-segment-audience-tools">
                                        <div class="newsletter-segment-audience-count">
                                            <button type="button" class="btn secondary" data-bind="event: { click: onClickCalculateRecipientCount }, disable: isRecipientCountLoading, css: { 'is-loading': isRecipientCountLoading }">Calculate Count of Targeted Email Addresses</button>
                                            <span class="form-text" data-bind="text: recipientCountLabel"></span>
                                            <!-- ko if: permissions()['website_user_export'] && permissions()['website_user_export'].read -->
                                            <button type="button" class="btn secondary icon i-export" data-bind="event: { click: onClickExportAudience }, disable: isAudienceExportLoading, css: { 'is-loading': isAudienceExportLoading }">Export CSV of Targeted Email Addresses</button>
                                            <!-- /ko -->
                                        </div>
                                        <div class="newsletter-segment-audience-lookup">
                                            <label class="form-label">User Lookup</label>
                                            <textarea class="input-text newsletter-segment-lookup-input" data-bind="value: audienceLookupEmails" placeholder="email@example.com, other@example.com"></textarea>
                                            <button type="button" class="btn secondary" data-bind="event: { click: onClickLookupAudience }, disable: isAudienceLookupLoading, css: { 'is-loading': isAudienceLookupLoading }">Check if Email Addresses are Targeted</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSend }" class="btn highlight">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAudienceLookupResultsVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form newsletter-segment-lookup-results-popup">
                        <div class="form-header">
                            <h3 class="form-title">Check Email Results</h3>
                            <button type="button" data-bind="event: { click: onClickCloseAudienceLookupResults }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                                <div class="newsletter-segment-lookup-results-summary">
                                    <div class="newsletter-segment-lookup-results-stat">
                                        <strong data-bind="text: audienceLookupTotalCount"></strong>
                                        <span>Checked</span>
                                    </div>
                                    <div class="newsletter-segment-lookup-results-stat is-match">
                                        <strong data-bind="text: audienceLookupMatchCount"></strong>
                                        <span>Matched</span>
                                    </div>
                                    <div class="newsletter-segment-lookup-results-stat is-no-match">
                                        <strong data-bind="text: audienceLookupNoMatchCount"></strong>
                                        <span>Not Matched</span>
                                    </div>
                                </div>
                                <div class="newsletter-segment-lookup-results-group is-match" data-bind="visible: audienceLookupMatchCount() > 0">
                                    <h4 class="newsletter-segment-lookup-results-heading" data-bind="text: 'Matched Addresses (' + audienceLookupMatchCount() + ')'"></h4>
                                    <ul class="newsletter-segment-lookup-results-list" data-bind="foreach: audienceLookupMatchedResults">
                                        <li class="form-text"><span data-bind="text: email"></span><strong>Targeted</strong></li>
                                    </ul>
                                </div>
                                <div class="newsletter-segment-lookup-results-group is-no-match" data-bind="visible: audienceLookupNoMatchCount() > 0">
                                    <h4 class="newsletter-segment-lookup-results-heading" data-bind="text: 'Not Matched Addresses (' + audienceLookupNoMatchCount() + ')'"></h4>
                                    <ul class="newsletter-segment-lookup-results-list" data-bind="foreach: audienceLookupUnmatchedResults">
                                        <li class="form-text"><span data-bind="text: email"></span><strong>Not Targeted</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseAudienceLookupResults }" class="btn">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            ${ this.tagVideoPicker.getHtmlBuild() }
            `;
    }

    protected getTemplateName(): string {
        return "newsletterEmail-template";
    }

    protected getMainElementClasses(): string[] {

        return ["newsletter-builder"];
    }

    public showTagPicker(mode, target) {

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.setTagPickerTarget(target);
        //this.caller.getTagData();
        this.tagPicker.show();
    }

    public setTagPickerTarget(tagPickerTarget) {
        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    protected initPartial() {

        this.templateSelector = new filterDropdown_template('templateSelector', this.getTemplateViewModel(), this.caller);
        this.templateSelector.setLabel('Template');
        this.dateSelector = new filterSingleDate_template('dateSelector', this.getTemplateViewModel(), this.caller);
        this.dateSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.dateSelector.setMinutesInterval(1);
        this.targetingBuilder = new newsletterTargetingBuilder_template('emailTargetingBuilder', this.getTemplateViewModel(), this.caller);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);
        this.tagPicker.tagView.set_enableTagVideo(false);

        this.articleFilter = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.customRecipientsToolTipButton = new infoButton_template('customRecipientsToolTipButton', this.getTemplateViewModel(), this.caller)
        this.customRecipientsToolTipButton.setTitle('Help: Custom');

        let customRecipientstoolTipText = '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<p>Input comma-separated email addresses to receive a copy of the email. Spaces will be stripped.</p>' +
            '</div>'
            ;

        this.customRecipientsToolTipButton.setContent(customRecipientstoolTipText);

        this.contentToolTipButton = new infoButton_template('contentToolTipButton', this.getTemplateViewModel(), this.caller)
        this.contentToolTipButton.setTitle('Help: Content');

        let contentToolTipText = `
        <ul>
            <li>
                [TOKEN] is a base64 encoded version of the email address with the brand shortname appended.
                <ol>
                    <li>Used for /page/newsletter/manage/[TOKEN]/ and /page/newsletter/unsubscribe/[TOKEN]/.</li>
                </ol>
            </li>
            <li>[RECEPIENTEMAIL] is the direct email address in text.</li>
        </ul>
        `;

        this.contentToolTipButton.setContent(contentToolTipText);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars(1);
        this.filterProducts.setPlaceholderAndLabel("Product");
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars(1);
        this.filterAffiliates.setPlaceholderAndLabel("Affiliate Partner");
        this.filterAffiliates.setOptionType("Affiliate Partner");

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        // this.filterProductTypes.setFilterIconCSSClass( 'i-article-a' );
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel('Product Type');
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars(1);
        this.filterProductTypes.setAddNewOptionEnabled(true);

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.bindRecipientCountUpdates();

        this.tagVideoPicker = new videoPicker_template("tagVideoPicker", this.getTemplateViewModel(), this.caller);
        this.videoPickerHelper = new videoPickerHelper(
            this.tagVideoPicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );
    }

    public buildDatePickerCalendar() {

        this.dateSelector.buildCalendar(this.createEasternTimeZoneDateTime());
    }

    protected buildViewModel(): any {
        let self = this
        let recipientCount = ko.observable(null);
        let isRecipientCountLoading = ko.observable(false);
        let audienceLookupResults = ko.observableArray([]);
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            content: ko.observable(""),
            sendToSelf: ko.observable(false),
            recipientEmails: ko.observable(""),
            recipients: ko.observableArray([]),
            selectedRecipients: ko.observableArray([]),
            recipientMode: ko.observable('mailingList'),
            availableSegments: ko.observableArray([]),
            selectedSegmentIds: ko.observableArray([]),
            audienceLookupEmails: ko.observable(''),
            audienceLookupResults: audienceLookupResults,
            audienceLookupMatchedResults: ko.pureComputed(() => {
                return audienceLookupResults().filter((result: any) => result.matches);
            }),
            audienceLookupUnmatchedResults: ko.pureComputed(() => {
                return audienceLookupResults().filter((result: any) => !result.matches);
            }),
            audienceLookupMatchCount: ko.pureComputed(() => {
                return audienceLookupResults().filter((result: any) => result.matches).length;
            }),
            audienceLookupNoMatchCount: ko.pureComputed(() => {
                return audienceLookupResults().filter((result: any) => !result.matches).length;
            }),
            audienceLookupTotalCount: ko.pureComputed(() => audienceLookupResults().length),
            isAudienceLookupResultsVisible: ko.observable(false),
            isAudienceLookupLoading: ko.observable(false),
            isAudienceExportLoading: ko.observable(false),
            isAudienceToolsOpen: ko.observable(false),
            recipientCount: recipientCount,
            isRecipientCountLoading: isRecipientCountLoading,
            recipientCountLabel: ko.pureComputed(function () {
                if (isRecipientCountLoading()) {
                    return 'Calculating audience...';
                }
                if (recipientCount() === null) {
                    return '';
                }
                return 'Audience count: ' + Number(recipientCount()).toLocaleString();
            }),
            imagePickerTarget: ko.observable(null),
            isArticleInsertPopUpVisible: ko.observable(false),
            articleInsertPreviewCode: ko.observable(''),
            isSaveAndSendPopUpVisible: ko.observable(false),
            tagPickerTarget: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['newsletter_email_view', 'newsletter_email_edit', 'website_user_export'])),
            selectedNewsLetterMode : ko.observable(null),
            availableNewsLetterTemplates : ko.observableArray([]),
            selectedTemplate : ko.observable(null),
            selectedTemplateId : ko.observable(null),
            finalPreviewElementId: ko.observableArray(null),
            onClickCancelEdit (data, event) {
                self.cancelEdit();
            },
            onClickSave (data, event) {
                self.onClickSave();
            },
            onClickSaveAndStay (data, event) {
                self.onClickSaveAndStay();
            },
            onClickSend (data, event) {
                self.onClickSend();
            },
            onClickCalculateRecipientCount (data, event) {
                self.onClickCalculateRecipientCount();
            },
            onClickExportAudience (data, event) {
                self.onClickExportAudience();
            },
            onClickLookupAudience (data, event) {
                self.onClickLookupAudience();
            },
            onClickCloseAudienceLookupResults (data, event) {
                self.onClickCloseAudienceLookupResults();
            },
            onClickToggleAudienceTools (data, event) {
                self.onClickToggleAudienceTools();
            },
            onFocusOutStaticPageName: (data, event) => {
                // self.onFocusOutStaticPageName(event);
            },
            onClickCloseArticlePopUp (data, event) {
                self.onClickCloseArticlePopUp();
            },
            onClickToggleSaveAndSendPopUp (value, data, event) {
                self.toggleSaveAndSendPopUp(value);
            },
            onClickInsertIntoEditor (data, event) {
                self.onClickInsertIntoEditor();
            },
            onClickSelectNewsLetterMode(newsLetterMode) {
                self.onClickSelectNewsLetterMode(newsLetterMode);
            },
            onClickSelectTemplate(template) {
                self.onClickSelectTemplate(template);
            }
        };
    }

    getViewModelForRequest(): any {
        let viewModel = this.getTemplateViewModel();
        let recipientMode = viewModel.recipientMode();
        let selectedSegmentIds = viewModel.selectedSegmentIds();
        return {
            idMail: viewModel.id(),
            content: viewModel.content(),
            idTemplate: this.templateSelector.getTemplateViewModel().selectedOption,
            selectedRecipients: recipientMode === 'mailingList' ? viewModel.selectedRecipients() : [],
            recipientEmails: viewModel.recipientEmails(),
            idSegment: recipientMode === 'segment' && selectedSegmentIds.length === 1 ? selectedSegmentIds[0] : null,
            targeting: recipientMode === 'mailingList' ? this.getDefaultTargetingCriteria() : this.getAudienceCriteria(),
            recipientMode: recipientMode,
            sendToSelf: viewModel.sendToSelf(),
            subject: viewModel.subject(),
            previewText: viewModel.previewText(),
            dateScheduled: this.dateSelector.getTemplateViewModel().singleDatePicker(),
            mode : viewModel.selectedNewsLetterMode(),
            selectedTemplate : viewModel.selectedTemplate(),
            selectedTemplateId : viewModel.selectedTemplateId(),
        };
    }

    public getAudienceLookupRequest(): any {
        return {
            emails: this.splitEmails(this.getTemplateViewModel().audienceLookupEmails()),
            criteria: this.getAudienceCriteria()
        };
    }

    public getAudienceCriteria(): any {
        let viewModel = this.getTemplateViewModel();
        if (viewModel.recipientMode() === 'mailingList') {
            return this.buildReferenceCriteria('mailingList', viewModel.selectedRecipients());
        }
        if (viewModel.recipientMode() === 'segment') {
            return this.buildReferenceCriteria('segment', viewModel.selectedSegmentIds());
        }

        return this.targetingBuilder ? this.targetingBuilder.getCriteria() : this.getDefaultTargetingCriteria();
    }

    public showImagePicker(mode, target, keyword = null) {

        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(target);
        this.caller.getImageData(keyword);
        if (mode === "multi-select") {
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public setTemplates(templates) {

        this.templateSelector.setOptions(templates);
    }

    public setRecipients(recipients) {

        this.getTemplateViewModel().recipients(recipients);
    }

    public setTargetingReferences(references) {
        if (this.targetingBuilder) {
            this.targetingBuilder.setReferences(references);
        }
        let segments = (references.segments || []).map((segment) => {
            return {
                id: segment.id,
                title: segment.title || segment.name
            };
        });
        this.getTemplateViewModel().availableSegments(segments);
    }

    public setAudienceLookupResults(results: Array<any>): void {
        let resultList = results || [];
        this.getTemplateViewModel().audienceLookupResults(resultList);
        this.getTemplateViewModel().isAudienceLookupResultsVisible(resultList.length > 0);
    }

    public setAudienceLookupLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isAudienceLookupLoading(isLoading);
    }

    private getDefaultTargetingCriteria(): any {
        return {
            version: 1,
            combinator: 'AND',
            filterGroups: [],
            exclusionGroups: [],
            externalEmails: []
        };
    }

    private buildReferenceCriteria(field: string, values: Array<any>): any {
        let criteria = this.getDefaultTargetingCriteria();
        if (!values || !values.length) {
            return criteria;
        }

        criteria.filterGroups = [{
            combinator: 'AND',
            conditions: [{
                field: field,
                operator: 'is_any_of',
                values: values.slice()
            }]
        }];
        return criteria;
    }

    private splitEmails(value: string): Array<string> {
        if (!value) {
            return [];
        }

        return value.split(',').map((email) => email.trim()).filter((email) => email !== '');
    }

    public setContent(content) {

        this.getTemplateViewModel().content(content);
    }

    public setDateScheduled(dateScheduled) {

        this.getTemplateViewModel().dateScheduled(dateScheduled);
    }

    public setIdTemplate(idTemplate) {

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public setId(id) {

        this.getTemplateViewModel().id(id);
    }

    public getImagePickerTarget() {
        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget) {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public setVideoPickerTagFilter(tags) {
        this.videoPickerHelper.setTagsSuggestions(tags);
    }

    public onClickSave() {

        this.caller.save('save');
    }

    public onClickSaveAndStay() {

        this.caller.save('stay');
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs = tpSections.filter((s) => s == sectionName);

        return (fs.length > 0);
    }

    public editTagElement(tagElement, editor) {

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor) {

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    public initTagPickerCkEditors(): void {

        this.tagPicker.initializeCkEditors();
    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public setSubject(subject) {

        this.getTemplateViewModel().subject(subject)
    }

    public setPreviewText(previewText) {

        this.getTemplateViewModel().previewText(previewText)
    }

    public toggleArticleInsertPopUp(bool) {

        this.getTemplateViewModel().isArticleInsertPopUpVisible(bool)
    }

    public setArticleInsertPreviewCode(html) {

        this.getTemplateViewModel().articleInsertPreviewCode(html)
    }

    public toggleSaveAndSendPopUp(bool) {

        this.getTemplateViewModel().isSaveAndSendPopUpVisible(bool);
        document.body.classList.toggle('_newsletter-save-send', Boolean(bool));
        this.dateSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
        if (!bool) {
            this.getTemplateViewModel().isRecipientCountLoading(false);
            this.getTemplateViewModel().isAudienceLookupLoading(false);
        }
    }

    public onClickCloseArticlePopUp() {

        this.toggleArticleInsertPopUp(false);
        this.resetArticleInsertPopUp();
    }

    public onClickInsertIntoEditor() {

        let html = this.getTemplateViewModel().articleInsertPreviewCode();
        const finalHtml = document.getElementById(this.getFinalPreviewElementId());
        if (finalHtml) {
            html = finalHtml.innerHTML;
            this.setFinalPreviewElementId(null);
            this.caller.insertIntoEditor(NwsLAB.refineHtml(html));
            this.resetArticleInsertPopUp();
            this.toggleArticleInsertPopUp(false);
            return;
        }
        this.caller.insertIntoEditor(html);
        this.resetArticleInsertPopUp();
        this.toggleArticleInsertPopUp(false);
    }

    public refineHtml(html: string): string {
        const container = document.createElement('div');
        container.innerHTML = html;
        container
            .querySelectorAll('[data-display="false"]')
            .forEach((element) => element.remove());
        container
            .querySelectorAll('[data-bind], [data-display]')
            .forEach((element) => {
                element.removeAttribute('data-bind');
                element.removeAttribute('data-display');
            });
        return container.innerHTML.trim();
    }


    public resetArticleInsertPopUp() {

        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().articleInsertPreviewCode("");
    }

    public onClickSend() {
        this.caller.sendNewsletter();
    }

    public onClickCalculateRecipientCount() {
        this.caller.refreshRecipientCount();
    }

    public onClickExportAudience() {
        this.caller.exportAudience();
    }

    public setAudienceExportLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isAudienceExportLoading(isLoading);
    }

    public onClickLookupAudience() {
        this.caller.lookupAudience();
    }

    public onClickCloseAudienceLookupResults() {
        this.getTemplateViewModel().isAudienceLookupResultsVisible(false);
    }

    public onClickToggleAudienceTools() {
        let viewModel = this.getTemplateViewModel();
        viewModel.isAudienceToolsOpen(!viewModel.isAudienceToolsOpen());
    }

    private bindRecipientCountUpdates() {
        let viewModel = this.getTemplateViewModel();
        let clearCount = () => {
            viewModel.recipientCount(null);
        };
        let clearAudienceOutputs = () => {
            clearCount();
            viewModel.audienceLookupResults([]);
            viewModel.isAudienceLookupResultsVisible(false);
        };

        viewModel.recipientMode.subscribe(clearAudienceOutputs);
        viewModel.selectedRecipients.subscribe(clearAudienceOutputs);
        viewModel.selectedSegmentIds.subscribe(clearAudienceOutputs);
        viewModel.sendToSelf.subscribe(clearCount);
        viewModel.audienceLookupEmails.subscribe(() => viewModel.audienceLookupResults([]));

        if (this.targetingBuilder) {
            let targetingViewModel = this.targetingBuilder.getTemplateViewModel();
            targetingViewModel.filterGroups.subscribe(clearAudienceOutputs);
            targetingViewModel.exclusionGroups.subscribe(clearAudienceOutputs);
            targetingViewModel.criteriaRevision.subscribe(clearAudienceOutputs);
            targetingViewModel.externalEmailsInput.subscribe(clearAudienceOutputs);
        }
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
        this.videoPickerHelper.setPermissions(permissions);
    }

    public cancelEdit() {

        this.caller.redirectToMailList()
    }

    public closeImage(target) {
        let element = document.getElementById(target);
        element!.classList.remove("is-viewing");
    }

    public removeImage(target) {

        if (target == 'video_thumbnail'){
            this.videoPickerHelper.clearThumbnailImage()
        }
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = !productsViewModel.addNewSelected() ? productsViewModel.optionObj() : null;
        let tagType = !typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse(JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse(JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if (image) {

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if (tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0) {

            tagType.fields.forEach(field => {

                spec = { fieldId: field.id, label: field.label, data: null, dataType: field.dataType };

                for (let i = 0; i < specValues.length; i++) {

                    if (specValues[i].idField == field.id) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i, 1);
                        break;
                    }
                }
                specs.push(spec);
            })
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public setProductImages(images) {

        for (let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {
                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }
            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private getFormattedEasternTimeZoneDateTime(): any {

        let date = this.createEasternTimeZoneDateTime();

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return year + '/' + this.padInteger(month, 2) + '/' + this.padInteger(day, 2) + ' ' + this.padInteger(hour, 2) + ':' + this.padInteger(minutes, 2);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    private padInteger(number: number, size: number) {
        let s = number + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved(date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public handleTagInArticle(target: string): void {
        switch (target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':

                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }

    public getNewsletterConfirmElement() {
        return document.getElementById('newsletter-confirm-identifier');
    }

    public setIsImageOptimized(val) {
        // TODO implement method when you delete an image through imagePickerHelper
    }

    public setFinalPreviewElementId(selector: string|null) {
        this.getTemplateViewModel().finalPreviewElementId(selector);
    }

    public getFinalPreviewElementId() {
        return this.getTemplateViewModel().finalPreviewElementId();
    }

    onClickSelectNewsLetterMode(newsLetterMode): any {
        this.setNewsletterMode(newsLetterMode);

        if (newsLetterMode === NwsLAB.CUSTOM_CONTENT_MODE || newsLetterMode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE) {
            this.caller.initializeCkEditors(newsLetterMode)
        }
    }

    onClickSelectTemplate(template) : any {
        this.setSelectedTemplate(template || null);
        this.setSelectedTemplateId(template.id || null);

        const newsLetterMode = this.getNewsletterMode();

        if (newsLetterMode === NwsLAB.CUSTOM_CONTENT_MODE || newsLetterMode === NwsLAB.CUSTOM_HEADER_CONTENT_FOOTER_MODE) {
            this.caller.initializeCkEditors(newsLetterMode)
        }
    }

    setNewsletterMode(mode) {
        this.getTemplateViewModel().selectedNewsLetterMode(mode);
    }
    getNewsletterMode() {
        return this.getTemplateViewModel().selectedNewsLetterMode();
    }

    setSelectedTemplate(template) {
        this.getTemplateViewModel().selectedTemplate(template);
    }

    getSelectedTemplate() {
        return this.getTemplateViewModel().selectedTemplate();
    }

    setSelectedTemplateId(id) {
        this.getTemplateViewModel().selectedTemplateId(id);
    }

    getSelectedTemplateId() {
        return this.getTemplateViewModel().selectedTemplateId();
    }

    setAvailableNewsLetterTemplates(templates) {
        this.getTemplateViewModel().availableNewsLetterTemplates(templates);
    }

    public getAvailableNewsLetterTemplates() {
        return this.getTemplateViewModel().availableNewsLetterTemplates();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterMailEdit_template.ts